// ** React Imports
import { lazy } from 'react';

const List = lazy(() => import('../../views/feedback'));

const FeedBackRoutes = [
  {
    element: <List />,
    path: '/feedback',
    meta: {
      permission: 'FEEDBACK'
    }
  }
];

export default FeedBackRoutes;
